const IMAGE_URL = "https://retailsystem.s3.amazonaws.com/CD2E6480FD8D";
const THUMBNAIL_URL = "https://rsl-thumbnails.s3.amazonaws.com/CD2E6480FD8D";

const DELETE_STORE_SCOPE = 'delete:stores';
const DELETE_STORE_SCOPES = [DELETE_STORE_SCOPE, 'delete:storecomponents', 'stores:components:view'];

const SHOPIFY_INFO_SCOPES = {
  STORE_URL: 'update:shopifyinfo-shopifyurl',
  APP_CREDENTIALS: 'update:shopifyinfo-appcredentials',
  SALES_CHANNELS: 'update:shopifyinfo-autoincludesaleschannels',
} as const;

const ALL_SCOPES = [
  'admin:users:manage',
  'stores:create',
  'stores:sync:unlimited',
  'write-force-sync',
  'update:storesyncsettings',
  'update:synctype',
  'update:rsinformation',
  'update:jsonsettings',
  'update:csvconfiguration',
  DELETE_STORE_SCOPE,
  'logs:view',
  'reports:view-details',
  SHOPIFY_INFO_SCOPES.STORE_URL,
  SHOPIFY_INFO_SCOPES.APP_CREDENTIALS,
  SHOPIFY_INFO_SCOPES.SALES_CHANNELS,
];

const PAGE_SIZE = 10;

const SIDE_BY_SIDE_DEFAULTS = {
  SECTION_TITLE_COLOR: '#000000',
  SECTION_SUBTITLE_COLOR: '#666666',
  DEFAULT_CARD: {
    image: '',
    title: '',
    subtitle: '',
    btnText: '',
    link: '',
    openInNewTab: false,
    titleColor: '#000000',
    subtitleColor: '#666666',
    btnColor: '#000000',
    imageRadius: 0,
    overlayOpacity: 0,
    objectFit: 'cover' as const,
    altText: '',
    showArrow: true,
  },
};

export default {
  IMAGE_URL,
  THUMBNAIL_URL,
  ALL_SCOPES,
  DELETE_STORE_SCOPE,
  DELETE_STORE_SCOPES,
  SHOPIFY_INFO_SCOPES,
  PAGE_SIZE,
  SIDE_BY_SIDE_DEFAULTS,
};
